!(function () {
  "use strict";
  var e,
    t = {
      4262: function (e, t, r) {
        var a = r(5117);
        function i() {
          let e = window.matchMedia("(min-width: 0px) and (max-width: 767px)"),
            t = window.matchMedia("(min-width: 768px)");
          const r = function (e) {
            let t = e.closest(".slider"),
              r = t.querySelectorAll("iframe, video"),
              i = t.querySelector(".swiper-pagination"),
              s = t.querySelector(".swiper-button-prev"),
              o = t.querySelector(".swiper-button-next"),
              n = e.hasAttribute("data-text-pagination"),
              l = parseInt(e.getAttribute("data-desktop-slides-per-view")),
              d = parseInt(e.getAttribute("data-mobile-slides-per-view")),
              p = parseInt(e.getAttribute("data-tablet-slides-per-view")),
              c = e.getAttribute("data-animation-style"),
              u = e.getAttribute("data-loop"),
              f = e.getAttribute("data-autoplay"),
              v = parseInt(e.getAttribute("data-autoplay-delay")),
              w = !1;
            "true" == f && (w = { delay: 1e3 * v });
            let m =new a.A(e, {
              effect: c,
              crossfade: !0,
              preloadImages: !1,
              loop: true,
              loopAddBlankSlides: !0,
              autoplay: false,
              watchSlidesProgress: !0,
              speed: 100,
              slidesPerView: "auto",
              freeMode: {
                enabled: true,
                momentum: true, // Enable momentum
                momentumBounce: false, // Disable bounce
              },
              breakpoints: {
                0: { slidesPerGroup: 1  },
                768: { slidesPerGroup: l },
                992: { slidesPerGroup: l, freeMode: false },
              },
              pagination: { el: i, clickable: !0 },
              navigation: { prevEl: n, nextEl: o },
              a11y: { enabled: !0 },
            });
            if (
              (t.classList.add("slider-enabled"),
              m.on("update", () => {
                Array.prototype.forEach.call(r, function (e) {
                  if ("video" === e.tagName.toLowerCase()) e.pause();
                  else {
                    var t = e.src;
                    e.src = t;
                  }
                });
                var e = m.activeIndex,
                  a = t
                    .getElementsByClassName("swiper-slide")
                    [e].getElementsByTagName("video")[0];
                a && a.play();
              }),
              m.on("transitionStart", () => {
                Array.prototype.forEach.call(r, function (e) {
                  if ("video" === e.tagName.toLowerCase()) e.pause();
                  else {
                    var t = e.src;
                    e.src = t;
                  }
                });
              }),
              m.on("transitionEnd", () => {
                var e = m.activeIndex,
                  r = t
                    .getElementsByClassName("swiper-slide")
                    [e].getElementsByTagName("video")[0];
                r && r.play();
              }),
              m.on("slideChange", function () {
                m.pagination.render(),
                  m.pagination.update(),
                  m.navigation.destroy(),
                  m.navigation.init();
              }),
              p && (m.params.breakpoints[768].slidesPerGroup = p),
              n)
            ) {
              (m.params.breakpoints[0].slidesPerView = 1),
                (m.params.breakpoints[0].slidesPerGroup = 1),
                (m.params.breakpoints[0].spaceBetween = 16),
                (m.params.breakpoints[768].slidesPerView = "auto"),
                (m.params.breakpoints[768].slidesPerGroup = 1),
                (m.params.breakpoints[768].spaceBetween = 32),
                (m.params.breakpoints[992].slidesPerView = "auto"),
                (m.params.breakpoints[992].slidesPerGroup = 1),
                (m.params.breakpoints[992].spaceBetween = 32),
                (m.currentBreakpoint = !1),
                m.update();
              let e = t.querySelectorAll(".slideshow-text-controls__item");
              m.on("slideChange", () => {
                e.forEach((e) => {
                  e.classList.remove("active");
                }),
                  e[m.realIndex].classList.add("active");
              }),
                e.forEach((e, t) => {
                  e.addEventListener("click", () => {
                    m.slideToLoop(t);
                  });
                });
            }
          };
          document.querySelectorAll(".swiper").forEach((a) => {
            let i = a.closest(".slider"),
              s = a.getAttribute("data-desktop-layout"),
              o = a.getAttribute("data-mobile-layout");
            "slider" == s && "slider" == o
              ? r(a)
              : "grid" == s && "slider" == o
              ? e.matches
                ? a.swiper || (r(a), a.swiper.update())
                : t.matches &&
                  a.swiper &&
                  (a.swiper.destroy(), i.classList.remove("slider-enabled"))
              : "slider" == s &&
                "grid" == o &&
                (t.matches
                  ? a.swiper || (r(a), a.swiper.update())
                  : e.matches &&
                    a.swiper &&
                    (a.swiper.destroy(), i.classList.remove("slider-enabled")));
          });
        }
        window.addEventListener("load", function () {
          i();
        }),
          window.addEventListener("resize", function () {
            i();
          }),
          Shopify.designMode &&
            document.addEventListener("shopify:section:load", () => {
              i();
            });
      },
    },
    r = {};
  function a(e) {
    var i = r[e];
    if (void 0 !== i) return i.exports;
    var s = (r[e] = { exports: {} });
    return t[e].call(s.exports, s, s.exports, a), s.exports;
  }
  (a.m = t),
    (e = []),
    (a.O = function (t, r, i, s) {
      if (!r) {
        var o = 1 / 0;
        for (p = 0; p < e.length; p++) {
          (r = e[p][0]), (i = e[p][1]), (s = e[p][2]);
          for (var n = !0, l = 0; l < r.length; l++)
            (!1 & s || o >= s) &&
            Object.keys(a.O).every(function (e) {
              return a.O[e](r[l]);
            })
              ? r.splice(l--, 1)
              : ((n = !1), s < o && (o = s));
          if (n) {
            e.splice(p--, 1);
            var d = i();
            void 0 !== d && (t = d);
          }
        }
        return t;
      }
      s = s || 0;
      for (var p = e.length; p > 0 && e[p - 1][2] > s; p--) e[p] = e[p - 1];
      e[p] = [r, i, s];
    }),
    (a.d = function (e, t) {
      for (var r in t)
        a.o(t, r) &&
          !a.o(e, r) &&
          Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (a.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (function () {
      var e = { 4057: 0 };
      a.O.j = function (t) {
        return 0 === e[t];
      };
      var t = function (t, r) {
          var i,
            s,
            o = r[0],
            n = r[1],
            l = r[2],
            d = 0;
          if (
            o.some(function (t) {
              return 0 !== e[t];
            })
          ) {
            for (i in n) a.o(n, i) && (a.m[i] = n[i]);
            if (l) var p = l(a);
          }
          for (t && t(r); d < o.length; d++)
            (s = o[d]), a.o(e, s) && e[s] && e[s][0](), (e[s] = 0);
          return a.O(p);
        },
        r = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
      r.forEach(t.bind(null, 0)), (r.push = t.bind(null, r.push.bind(r)));
    })();
  var i = a.O(void 0, [8096], function () {
    return a(4262);
  });
  i = a.O(i);
})();
